const DEFAULT_START_DATE = new Date('1970-01-01T00:00');

export default DEFAULT_START_DATE;
